import { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import { useSelector ,useDispatch} from "react-redux";
import "./mydata.css";
import MydataModal from "./modalForMydata/mydatamodal";
import { getmyinfoAction } from "../../../../../redux/reducer/getmyinfo/action/action";
import { getMyImageAction } from "../../../../../redux/reducer/getMyimg/action/action";
import Spinner from 'react-bootstrap/Spinner';
import EditMyProfile from "../editMyProfile/editMyProfile";
import "./mydataDark.css"
import axios from "axios";
import sockets from "../../../../../socket/socket";
import { useNavigate } from "react-router";
const socket = sockets;


export default function Mydata() {
      
        const  [data,setData] = useState([])
        const dispatch = useDispatch()
        const myinfo = useSelector(data=> data.getMayInfoReducer.myinfo)
        const myinfos = useSelector(data=> data.getMyImageReducer)
        const navigate = useNavigate()
          
         
          const getDarkModoe = useSelector(darkModes => darkModes )
          const getmyinforeducer = useSelector(compID => compID.getMayInfoReducer);
    useEffect(()=>{
    
        dispatch(getmyinfoAction("/registration/v2/api"))
        dispatch(getMyImageAction("/registration/v2/api"))
     
    },[dispatch])
  // Здесь мы получаем информацию о нас


  const logoutHandle = () => {
    socket.emit("updateForOnlineUsersStatus")
    axios({
        method: 'get',
        url: '/logout/api',
    })
        .then(function (response) {
            socket.emit('logout', getmyinforeducer.myinfo._id)

            sessionStorage.clear()
            navigate("/login")
            socket.emit('updateMydataOnlineTrueForServer');
            // window.location.replace("/login")

        });
    // return redirect("/login");
}
      if (myinfo) {
        return (
          <>
            <div className={getDarkModoe.ToggleDarkModeReducer.chekced?"mydataContDark":"mydataCont"}>
                <EditMyProfile />
               
          </div>
          <button onClick={logoutHandle}>Выйти</button>
          </>
        
        );
      }else{
       <h1>OOps</h1>
      }
  
}
